export default class PanelGroup {
  id: number;
  meter_id: number;
  name: string;
  peak_in_watt: number;
  azimuth_in_degrees: number;
  tilt_in_degrees: number;
  created_at: Date;
  updated_at: Date;

  constructor(params?: PanelGroup) {
    Object.assign(this, params);
  }

  static fromJson(json: string): PanelGroup {
    return Object.assign(new PanelGroup(), json);
  }

  isComplete(): boolean {
    return (
      this.peak_in_watt != null &&
      this.azimuth_in_degrees != null &&
      this.tilt_in_degrees != null
    );
  }
}
